import React, { createContext, useContext, useCallback } from 'react'
import useStatementStream from '../hooks/useStatementStream.js'
import useMetricsStream from '../hooks/useMetricsStream.js'
import useActivityStream from '../hooks/useActivityStream.js'

const StreamsContext = createContext(null)

export const useStreams = () => {
  const context = useContext(StreamsContext)
  if (!context) {
    throw new Error('useStreams must be used within StreamsProvider')
  }
  return context
}

export const StreamsProvider = ({ children, onStoredKeyUsed }) => {
  // Initialize activity stream (for Activity Stream page)
  const activityStream = useActivityStream({
    autoStart: true,
    onStoredKeyUsed
  })

  // Initialize statement stream for Live Monitor (no filters, always shows all events)
  const liveMonitorStream = useStatementStream({
    autoStart: true,
    storagePrefix: 'live-monitor-'
  })

  // Initialize statement stream for Statements page (with statement-specific filtering)
  const statementsStream = useStatementStream({
    autoStart: true,
    storagePrefix: 'statements-'
  })

  // Initialize metrics stream (for Metrics page)
  const metricsStream = useMetricsStream({ autoStart: true })

  const value = {
    activityStream,
    liveMonitorStream,
    statementsStream,
    metricsStream,
  }

  return (
    <StreamsContext.Provider value={value}>
      {children}
    </StreamsContext.Provider>
  )
}
